import submitCommand from '../../../services/submitCommand';
import { CourseStep } from '../models/course';

export const editThirdPartyVideoUrl = (
  courseId: string,
  taskId: string,
  videoUrl: string,
  thirdPartySite: 'YouTube' | 'Vimeo',
  stepName: string,
  order: number,
  initiatingUserId: string
): Promise<CourseStep> => {
  return submitCommand(
    courseId,
    {
      id: courseId,
      taskId: taskId,
      videoUrl: videoUrl,
      thirdPartySite: thirdPartySite,
      initiatingUserId: initiatingUserId,
    },
    'SetThirdPartyVideoUrl',
    'ThirdPartyVideoUrlSet',
    'TaskListError'
  ).then(() => ({
    _id: { id: taskId },
    _type: 'ThirdPartyVideo',
    taskName: stepName,
    order,
  }));
};
